import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";

import { Link } from "react-router-dom";
import { Tabs, Tab, Box } from "@mui/material";
import { useDropzone } from "react-dropzone";
import SplashText from "./SplashText";
import ToggleSwitch from "../ToggleSwitch";
import { Tooltip } from "react-tooltip";
import UseToast from "../../UseToast";
import SplashContent from "./SplashContent";
import SlidePanelForm from "./SlidePanelForm";
import ButtonSlidePanelForm from "./ButtonSlidePanelForm";
import { Typography } from "@mui/material";
import CalendarScheduler from "./CalendarScheduler";
import AirtableIntegration from "../Airtable/AirtableIntegration";
import { MuiColorInput } from "mui-color-input";
import CaptionUploadModal from "../../CaptionUploadModal";
import { useCaptionUpload } from "../../../hooks/useCaptionUpload";
import LanguageSelector from "./LanguageSelector";
import useFontFamilies from "../../../hooks/useFontFamilies";

export default function ButtonSettings() {
  const fontOptions = useFontFamilies('option');
  const [menuName, setMenuName] = useState("");
  const [submenuNames, setSubmenuNames] = useState({}); // Object to track submenu names
  const [menus, setMenus] = useState([]);
  const { id } = useParams(); // Get the optional client ID from the route
  const { showMsgSuccessToast, showErrorToast } = UseToast(); // Use the custom hook
  const navigate = useNavigate();
  const isEffectRan = useRef(false); // Track if useEffect has run

  const [isPanelOpen, setIsPanelOpen] = useState(false);

  const [openButtonId, setOpenButtonId] = useState(null); // Track which button is open

  const [availableLanguages, setAvailableLanguages] = useState([]);
  const [currentLanguage, setCurrentLanguage] = useState("en");
  const [loadingLanguages, setLoadingLanguages] = useState(false);

  // States for four different files
  const [leftTopMedia, setLeftTopMedia] = useState(null);
  const [leftBottomMedia, setLeftBottomMedia] = useState(null);
  const [rightTopMedia, setRightTopMedia] = useState(null);
  const [rightBottomMedia, setRightBottomMedia] = useState(null);
  const [splashVideoMedia, setSplashVideoMedia] = useState(null);
  const [splashVideoMediaTwo, setSplashVideoMediaTwo] = useState(null);
  const [splashVideoMediaThree, setSplashVideoMediaThree] = useState(null);
  const [centerLogoMedia, setCenterLogoMedia] = useState(null);
  const [menuBackButton, setMenuBackButton] = useState(null);
  const [centerBelowMenuMedia, setCenterBelowMenuMedia] = useState(null);
  const [splashText, setSplashText] = useState("");
  const [videotime, setVideoTime] = useState(0);
  const [buttonColor, setButtonColor] = useState("");

  const [frontendmainmenu, setFrontMainMenus] = useState([]);
  const [frontMainmenuName, setFrontMainMenuName] = useState([null]);
  const [menuUrl, setMenuUrl] = useState("");
  const [airtableEnabled, setAirtableEnabled] = useState(false);
  const [isAirtableEnabled, setIsAirtableEnabled] = useState(false);
  const [isWayfinderEnabled, setIsWayfinderEnabled] = useState(false);

  const [uploadingStates, setUploadingStates] = useState({
    leftTop: false,
    leftBottom: false,
    rightTop: false,
    rightBottom: false,
    splashVideo: false,
    splashVideotwo: false,
    splashVideothree: false,
    centerLogo: false,
    centerBelowMenuMedia: false,
    menuBackButton: false,
  });
  const [uploadedUrls, setUploadedUrls] = useState({
    leftTop: {
      fileName: "",
      fileUrl: "",
      enabled: false,
      width: 0,
      height: 0,
    },
    leftBottom: {
      fileName: "",
      fileUrl: "",
      enabled: false,
      width: 0,
      height: 0,
    },
    rightTop: {
      fileName: "",
      fileUrl: "",
      enabled: false,
      width: 0,
      height: 0,
    },
    rightBottom: {
      fileName: "",
      fileUrl: "",
      enabled: false,
      width: 0,
      height: 0,
    },
    splashVideo: {
      fileName: "",
      fileUrl: "",
      enabled: false,
      captionFile: "",
    },
    splashVideotwo: {
      fileName: "",
      fileUrl: "",
      enabled: false,
      captionFile: "",
    },
    splashVideothree: {
      fileName: "",
      fileUrl: "",
      enabled: false,
      captionFile: "",
    },
    centerLogo: {
      fileName: "",
      fileUrl: "",
      enabled: false,
      width: 0,
      height: 0,
    },
    centerBelowMenuMedia: {
      fileName: "",
      fileUrl: "",
      enabled: false,
      width: 0,
      height: 0,
    },
    menuBackButton: {
      fileName: "",
      fileUrl: "",
      enabled: false,
      width: 0,
      height: 0,
    },
  });

  const [settings, setSettings] = useState({
    userId: null,
    globalSettings: {
      height: 50,
      width: 150,
      font: "Arial",
      fontColor: "#127E10",
      fontSize: 16,
      shadow: {
        angle: 5,
        size: 10,
        distance: 5,
        alpha: 0.5,
        color: "#FF5733", // Bright orange
      },
      highlight: {
        fontColor: "#000",
      },
      textAlign: "center",
    },

    enabled: false,
  });

  // Add separate modal states for each video
  const [modalStates, setModalStates] = useState({
    splashVideo: false,
    splashVideotwo: false,
    splashVideothree: false,
  });

  // Add separate caption file states for each video
  const [captionFiles, setCaptionFiles] = useState({
    splashVideo: null,
    splashVideotwo: null,
    splashVideothree: null,
  });

  // Update the modal handlers
  const openCaptionModal = (videoKey) => {
    setModalStates((prev) => ({
      ...prev,
      [videoKey]: true,
    }));
  };

  const closeCaptionModal = (videoKey) => {
    setModalStates((prev) => ({
      ...prev,
      [videoKey]: false,
    }));
  };

  const { handleCaptionUpload: uploadCaption } = useCaptionUpload();
  const [captionFile, setCaptionFile] = useState(null);

  // Update the modal call
  const handleCaptionUpload = async (
    captionFile,
    convertSrtToVtt,
    videoKey,
  ) => {
    try {
      await uploadCaption(
        captionFile,
        convertSrtToVtt,
        setUploadedUrls,
        videoKey,
        id,
      );
      setCaptionFile(null);
    } catch (error) {
      // Error is already handled in the hook
    }
  };

  const handleOpenPanel = (buttonId) => {
    setOpenButtonId((prevId) => (prevId === buttonId ? null : buttonId)); // Toggle panel
  };

  const handleSave = async (config) => {
    try {
      const response = await axios.post("/api/frontend-main-settings", {
        ...config,
        userId: id,
      });
      console.log("Data saved:", response.data);
    } catch (error) {
      console.error("Error saving settings:", error);
    }
  };

  const handleSaveButton = async (config) => {
    try {
      const response = await axios.post("/api/frontendbutton-main-settings", {
        numColumns: config?.numColumns,
        columnSpacing: config?.columnSpacing,
        enableOffset: config?.enableOffset,
        leftOffset: config?.leftOffset,
        topOffset: config?.topOffset,
        btnId: config?.buttonId,
        rightOffset: config?.rightOffset,
        // lineHeight: config?.lineHeight,
        // padding: config?.padding,
        // fontSize: config?.fontSize,

        /////////////////////////New added//////////////
        disableAnimation: config?.disableAnimation,

        enableVideoEndOffset: config?.enableVideoEndOffset,
        videoEndTopOffset: config?.videoEndTopOffset,
        videoEndLeftOffset: config?.videoEndLeftOffset,
        videoEndRightOffset: config?.videoEndRightOffset,

        enableNextNavigation: config?.enableNextNavigation,

        nextButtonTopOffset: config?.nextButtonTopOffset,
        nextButtonLeftOffset: config?.nextButtonLeftOffset,
        nextButtonRightOffset: config?.nextButtonRightOffset,
        nextButtonBottomOffset: config?.nextButtonBottomOffset,

        wheelchairContentOffsetY: config?.wheelchairContentOffsetY,

         // Video End Navigation
        enableVideoEndNavigation: config?.enableVideoEndNavigation,
        videoEndNavigationMenuId: config?.videoEndNavigationMenuId,
      });
      console.log("Data saved:", response.data);
    } catch (error) {
      console.error("Error saving settings:", error);
    }
  };

  useEffect(() => {
    if (id && !isEffectRan.current) {
      isEffectRan.current = true; // Mark as ran

      runApi(localStorage.getItem(`language_pref_${id}`));
    }
  }, [id]);

  const fetchAvailableLanguages = async () => {
    try {
      setLoadingLanguages(true);
      const response = await axios.get(`/api/language/${id}`);
      if (response.data.success) {
        setAvailableLanguages(response.data.languages || ["en"]);

        // Try to get saved language preference from localStorage
        const savedLang = localStorage.getItem(`language_pref_${id}`);
        if (savedLang && response.data.languages.includes(savedLang)) {
          setCurrentLanguage(savedLang);
          // Update all data with the selected language
          // fetchDataWithLanguage(savedLang);
        } else {
          // Default to first language or 'en'
          setCurrentLanguage(response.data.languages[0] || "en");
        }
      }
    } catch (error) {
      console.error("Error fetching languages:", error);
      setAvailableLanguages(["en"]);
      setCurrentLanguage("en");
    } finally {
      setLoadingLanguages(false);
    }
  };

  const runApi = async (lang = "en") => {
    try {
      // Fetch initial data in default language
      const response = await axios.get(`/api/menus/${id}/${lang}`);
      if (response.data.error) {
        showErrorToast("No Menus Found");
        setButtonColor(response.data?.site_brand_color);
        setMenuUrl(response.data?.menu_client_url);
      } else {
        const frontendMenuNames = (
          response.data?.data.frontendmainmenu || []
        ).map((fm) => {
          const matchingMenu = response.data?.data.menus.find(
            (menu) => menu._id === fm.linkbtnId,
          );
          return {
            ...fm,
            matchedMenuName: fm?.linkedTrivia
              ? "(Trivia Quiz)"
              : matchingMenu
                ? `(${matchingMenu.name})`
                : "",
          };
        });

        const filterMenus = (response.data?.data.menus || []).map((fm) => {
          const submenus =
            fm.submenus?.map((smenu) => {
              const matchingMenu = response.data?.data.menus.find(
                (menu) => menu._id === smenu.linkbtnId,
              );

              return {
                ...smenu,
                name: smenu?.linkedTrivia
                  ? `${smenu?.name} (Trivia Quiz)`
                  : matchingMenu
                    ? `${smenu?.name} (${matchingMenu.name})`
                    : smenu?.mainMeuLinked
                      ? `${smenu?.name} (Main Menu)`
                      : smenu?.name,
              };
            }) || [];

          return {
            ...fm,
            submenus,
          };
        });

        setFrontMainMenus(frontendMenuNames);
        setMenus(filterMenus);
        setButtonColor(response.data?.site_brand_color);
        setMenuUrl(response.data?.menu_client_url);
        setIsAirtableEnabled(response.data.data?.isAirtableEnabled);
      }

      // Fetch available languages
      await fetchAvailableLanguages();

      // Fetch client settings to check wayfinder access
      await fetchClientSettings();
    } catch (error) {
      console.error("Error in runApi:", error);
    }
  };

  const fetchClientSettings = async () => {
    try {
      const res = await axios.get(`/auth/settings/client/${id}`);
      const featureAccess = res.data?.settings?.featureAccess;

      console.log("featureAcess", featureAccess)
      setIsWayfinderEnabled(featureAccess?.wayfinderEnabled || false);
    } catch (error) {
      console.error('Error fetching client settings:', error);
      setIsWayfinderEnabled(false);
    }
  };

  // Create a new menu
  const createMenu = () => {
    if (!menuName.trim()) return; // Prevent empty menu creation
    axios
      .post("/api/menu", {
        name: menuName,
        submenus: [],
        userId: id,
        currentLanguage: currentLanguage,
      })
      .then((response) => {
        if (!response.data.error) {
          runApi(currentLanguage);
          //setMenus(response.data?.result?.menus);
          setMenuName("");
        } else {
          showErrorToast(response.data?.msg);
        }
      });
  };

  const createFrontMainMenu = () => {
    if (!frontMainmenuName.trim()) return; // Prevent empty menu creation
    axios
      .post("/api/frontendmainmenu", {
        name: frontMainmenuName,
        userId: id,
        currentLanguage: currentLanguage,
      })
      .then((response) => {
        if (!response.data.error) {
          runApi(currentLanguage);
          // setFrontMainMenus(response.data?.result?.frontendmainmenu);
          setFrontMainMenuName("");
        } else {
          showErrorToast(response.data?.msg);
        }
      });
  };

  // Toggle menu visibility
  const toggleMenuVisibility = (menuId, isVisible, frontend = false) => {
    axios
      .post(`/api/main-menu-visibility`, {
        userId: id,
        menuId: menuId,
        isVisible: !isVisible,
        frontend,
      })
      .then((response) => {
        // setFrontMainMenus(response.data?.frontendmainmenu);
        // setMenus(response.data?.menus);
        const frontendMenuNames = (response.data?.frontendmainmenu || []).map(
          (fm) => {
            const matchingMenu = response.data?.menus.find(
              (menu) => menu._id === fm.linkbtnId,
            );
            return {
              ...fm,
              matchedMenuName: matchingMenu ? `(${matchingMenu.name})` : "",
            };
          },
        );

        setFrontMainMenus(frontendMenuNames);
        setMenus(response.data?.menus);
        //setButtonColor(response.data?.site_brand_color);
      });
  };

  const toggleSubmenuVisibility = (menuId, submenuId, isVisible) => {
    axios
      .post(`/api/main-submenu-visibility`, {
        userId: id,
        menuId: menuId,
        submenuId: submenuId,
        isVisible: !isVisible,
      })
      .then((response) => {
        setMenus(response.data.menus);
      });
  };

  // Add a submenu to an existing menu
  const addSubmenu = (menuId) => {
    const submenuName = submenuNames[menuId]?.trim();
    if (!submenuName) return; // Prevent empty submenu creation
    axios
      .post(`/api/menu/add-submenu`, {
        menuId: menuId,
        name: submenuName,
        isVisible: true,
        userId: id,
        currentLanguage: currentLanguage,
      })
      .then((response) => {
        if (!response.data.error) {
          //  setMenus(response.data?.result?.menus);

          runApi(currentLanguage);

          setSubmenuNames((prev) => ({ ...prev, [menuId]: "" })); // Clear input for the current menu
        } else {
          showErrorToast(response.data?.msg);
        }
      });
  };

  // Handle submenu input changes
  const handleSubmenuInputChange = (menuId, value) => {
    setSubmenuNames((prev) => ({ ...prev, [menuId]: value }));
  };

  const deleteMenu = (menuId, frontend = false) => {
    axios
      .post(`/api/delete-main-menu`, { menuId, userId: id, frontend })
      .then(() => {
        setFrontMainMenus((prevMenus) =>
          prevMenus.filter((menu) => menu._id !== menuId),
        );
        setMenus((prevMenus) =>
          prevMenus.filter((menu) => menu._id !== menuId),
        );
      })
      .catch((error) => {
        console.error("Error deleting menu:", error);
      });
  };

  // Delete Submenu
  const deleteSubmenu = (menuId, submenuId) => {
    axios
      .post(`/api/delete-submain-menu`, { menuId, submenuId, userId: id })
      .then((response) => {
        setMenus(response.data.menus); // Update the menus after deletion
      })
      .catch((err) => console.error(err));
  };

  const [value, setValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  // Content Upload

  useEffect(() => {
    if (id && currentLanguage) {
      fetchMedia(id, currentLanguage);
    }
  }, [id, currentLanguage]);

  useEffect(() => {
    if (id) {
      fetch(`/api/menupage-get-user-global/${id}`)
        .then((res) => res.json())
        .then((data) => {
          console.log("data", data);
          if (!data.error) {
            setSettings((prevSettings) => ({
              ...prevSettings,
              globalSettings: {
                ...prevSettings?.globalSettings,
                ...data.result?.globalSettings, // Merge globalSettings as well
              },
            }));
          }
        })
        .catch(() => console.log("Button not found, creating new settings."));
    }
  }, [id]);

  const fetchMedia = async (id, lang = "en") => {
    try {
      // Make an API call to get media data for the user with language support
      const response = await axios.get(
        `/api/get-menupage-content/${id}/${lang}`,
      );
      const mediaData = response.data; // Access the first object in the array

      setVideoTime(mediaData?.videotime || 0);

      // Update the state with the retrieved media data
      setUploadedUrls((prevUrls) => ({
        ...prevUrls, // Preserve previous data
        leftTop: {
          fileName: mediaData?.leftTop?.fileName || "",
          fileUrl: mediaData?.leftTop?.fileUrl || "",
          enabled: mediaData?.leftTop?.enabled || false,
          width: mediaData?.leftTop?.width || 0,
          height: mediaData?.leftTop?.height || 0,
        },
        leftBottom: {
          fileName: mediaData?.leftBottom?.fileName || "",
          fileUrl: mediaData?.leftBottom?.fileUrl || "",
          enabled: mediaData?.leftBottom?.enabled || false,
          width: mediaData?.leftBottom?.width || 0,
          height: mediaData?.leftBottom?.height || 0,
        },
        rightTop: {
          fileName: mediaData?.rightTop?.fileName || "",
          fileUrl: mediaData?.rightTop?.fileUrl || "",
          enabled: mediaData?.rightTop?.enabled || false,
          width: mediaData?.rightTop?.width || 0,
          height: mediaData?.rightTop?.height || 0,
        },
        rightBottom: {
          fileName: mediaData?.rightBottom?.fileName || "",
          fileUrl: mediaData?.rightBottom?.fileUrl || "",
          enabled: mediaData?.rightBottom?.enabled || false,
          width: mediaData?.rightBottom?.width || 0,
          height: mediaData?.rightBottom?.height || 0,
        },
        splashVideo: {
          fileName: mediaData?.splashVideo?.fileName || "",
          fileUrl: mediaData?.splashVideo?.fileUrl || "",
          enabled: mediaData?.splashVideo?.enabled || false,
          captionFile: mediaData?.splashVideo?.captionFile || "",
        },
        splashVideotwo: {
          fileName: mediaData?.splashVideotwo?.fileName || "",
          fileUrl: mediaData?.splashVideotwo?.fileUrl || "",
          enabled: mediaData?.splashVideotwo?.enabled || false,
          captionFile: mediaData?.splashVideotwo?.captionFile || "",
        },
        splashVideothree: {
          fileName: mediaData?.splashVideothree?.fileName || "",
          fileUrl: mediaData?.splashVideothree?.fileUrl || "",
          enabled: mediaData?.splashVideothree?.enabled || false,
          captionFile: mediaData?.splashVideothree?.captionFile || "",
        },
        centerLogo: {
          fileName: mediaData?.centerLogo?.fileName || "",
          fileUrl: mediaData?.centerLogo?.fileUrl || "",
          enabled: mediaData?.centerLogo?.enabled || false,
          width: mediaData?.centerLogo?.width || 0,
          height: mediaData?.centerLogo?.height || 0,
        },
        centerBelowMenuMedia: {
          fileName: mediaData?.centerBelowMenuMedia?.fileName || "",
          fileUrl: mediaData?.centerBelowMenuMedia?.fileUrl || "",
          enabled: mediaData?.centerBelowMenuMedia?.enabled || false,
          width: mediaData?.centerBelowMenuMedia?.width || 0,
          height: mediaData?.centerBelowMenuMedia?.height || 0,
        },
        menuBackButton: {
          fileName: mediaData?.menuBackButton?.fileName || "",
          fileUrl: mediaData?.menuBackButton?.fileUrl || "",
          enabled: mediaData?.menuBackButton?.enabled || false,
          width: mediaData?.menuBackButton?.width || 0,
          height: mediaData?.menuBackButton?.height || 0,
        },
      }));

      setSplashText(mediaData?.splashText ?? ""); // Default to an empty string only if splashText is null or undefined
    } catch (error) {
      console.error("Failed to fetch media data:", error);
    }
  };

  // Drop handlers for different media
  const createDropHandler = (setMedia) => (acceptedFiles) => {
    if (acceptedFiles.length > 0) {
      setMedia(acceptedFiles[0]);
    }
  };

  // Common upload handler
  const handleUpload = async (file, position) => {
    if (!file) {
      showErrorToast(`Please select a file for ${position} first!`);
      return;
    }

    // Set the specific position to uploading
    setUploadingStates((prev) => ({ ...prev, [position]: true }));

    try {
      // Step 1: Get Pre-signed URL from the Backend
      const response = await axios.get("/generate-signed-url", {
        params: {
          fileName: file.name,
          fileType: file.type,
        },
      });

      const { url } = response.data;

      // Step 2: Upload the File to S3
      await axios.put(url, file, {
        headers: {
          "Content-Type": file.type,
        },
      });

      // Step 3: Save Uploaded File Information
      const fileUrl = url.split("?")[0];

      setUploadedUrls((prev) => ({
        ...prev,
        [position]: {
          fileName: file.name, // Store file name
          fileUrl: fileUrl, // Store file URL
        },
      }));
      setUploadingStates((prev) => ({ ...prev, [position]: false }));

      setUploadedUrls((prevState) => ({
        ...prevState,
        [position]: {
          ...prevState[position],
          enabled: true,
        },
      }));
    } catch (error) {
      console.error("Upload failed:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    settings.userId = id;
    try {
      await axios.post("/api/save-menupage-content", {
        userId: id,
        mediaData: uploadedUrls,
        splashText: splashText,
        videotime: videotime,
        language: currentLanguage, // Include current language
      });

      if (settings?.enabled) {
        await fetch(`/api/menupage-save-user-global-settings`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(settings),
        });
      }

      showMsgSuccessToast(
        `Settings saved successfully for ${getLanguageName(currentLanguage)}!`,
      );
    } catch (error) {
      console.error("Failed to save media data:", error);
      showErrorToast("Error saving media data!");
    }
  };

  const handleToggleChange = async (isOn) => {
    console.log("Toggle state:", isOn);
    setSettings((prevSettings) => ({
      ...prevSettings,
      enabled: isOn, // Update the 'enabled' setting
    }));

    settings.enabled = isOn;
    settings.userId = id;
  };

  const handleChange = (key, value) => {
    // Determine whether to update global or custom settings
    const basePath = "globalSettings";
    const fullPath = `${basePath}.${key}`;
    const keys = fullPath.split("."); // Split the path into parts
    const newSettings = { ...settings };

    keys.reduce((obj, currentKey, index) => {
      if (index === keys.length - 1) {
        // If it's the last key, update the value
        obj[currentKey] = value;
      } else {
        // Otherwise, ensure the object exists before traversing
        obj[currentKey] = { ...obj[currentKey] };
      }
      return obj[currentKey];
    }, newSettings);

    setSettings(newSettings);
  };

  const handleToggleChangeMedia = (mediaKey, on) => {
    setUploadedUrls((prevState) => ({
      ...prevState,
      [mediaKey]: {
        ...prevState[mediaKey],
        enabled: on,
      },
    }));
  };

  const truncateText = (text, maxLength) => {
    if (!text) return "";

    // Handle if text is an object (multi-language support)
    let textString = text;
    if (typeof text === "object") {
      // Try to get the current language text, fallback to 'en', or first available
      textString =
        text[currentLanguage] || text["en"] || text[Object.keys(text)[0]] || "";
    }

    // Convert to string if it's not already
    textString = String(textString);

    // Remove <br> tags (both <br> and <br/>)
    const cleanText = textString.replace(/<br\s*\/?>/gi, " ");

    return cleanText.length > maxLength
      ? `${cleanText.slice(0, maxLength)}...`
      : cleanText;
  };

  function adjustHeights() {
    const menuCards = document.querySelectorAll(".submenu-list");

    let maxHeight = 0;

    // Reset all card heights first (important for dynamic resizing)
    menuCards.forEach((card) => {
      card.style.minHeight = "auto";
    });

    // Find the tallest box
    menuCards.forEach((card) => {
      maxHeight = Math.max(maxHeight, card.offsetHeight);
    });

    // Apply the tallest height to all cards
    menuCards.forEach((card) => {
      card.style.minHeight = `${maxHeight}px`;
    });
  }

  useEffect(() => {
    // Adjust heights on initial render
    adjustHeights();

    // Adjust heights on window resize
    window.addEventListener("resize", adjustHeights);

    return () => {
      window.removeEventListener("resize", adjustHeights);
    };
  }, [submenuNames, menus, value]);

  const handleToggleAirtable = () => {
    setAirtableEnabled(!airtableEnabled);
  };

  const handleBackToMenu = () => {
    setAirtableEnabled(false);
    runApi(localStorage.getItem(`language_pref_${id}`));
  };

  // Function to change language
  const handleLanguageChange = async (langCode) => {
    setCurrentLanguage(langCode);

    // Save preference to localStorage
    localStorage.setItem(`language_pref_${id}`, langCode);

    // Fetch menu data with new language
    await runApi(langCode);

    // Fetch media content with new language
    await fetchMedia(id, langCode);

    // Show success message
    showMsgSuccessToast(`Language changed to ${getLanguageName(langCode)}`);
  };

  // Helper function to get language name
  const getLanguageName = (code) => {
    const languageNames = {
      en: "English",
      es: "Spanish",
      fr: "French",
      de: "German",
      it: "Italian",
      pt: "Portuguese",
      ru: "Russian",
      zh: "Chinese",
      ja: "Japanese",
      ko: "Korean",
      ar: "Arabic",
      hi: "Hindi",
      tr: "Turkish",
      nl: "Dutch",
      sv: "Swedish",
      pl: "Polish",
      th: "Thai",
      vi: "Vietnamese",
      id: "Indonesian",
    };
    return languageNames[code] || code.toUpperCase();
  };

  // Helper function to get language flag
  const getLanguageFlag = (code) => {
    const flagMap = {
      en: "us",
      es: "es",
      fr: "fr",
      de: "de",
      it: "it",
      pt: "pt",
      ru: "ru",
      zh: "cn",
      ja: "jp",
      ko: "kr",
      ar: "sa",
      hi: "in",
      tr: "tr",
      nl: "nl",
      sv: "se",
      pl: "pl",
      th: "th",
      vi: "vn",
      id: "id",
    };
    return flagMap[code] || "xx";
  };

  return (
    <div className="main-container">
      <div className="pd-ltr-20 xs-pd-20-10">
        <div className="min-height-200px">
          <div className="page-header">
            <div className="row">
              <div className="col-md-6 col-sm-12">
                <div className="title">
                  <Typography variant="h4">
                    Main Menu{""}
                    {menuUrl && (
                      <>
                        <Typography
                          component="span"
                          sx={{ fontWeight: "bold", mx: 1 }}
                        >
                          {">>"}
                        </Typography>
                        {menuUrl.charAt(0).toUpperCase() + menuUrl.slice(1)}
                      </>
                    )}
                  </Typography>
                </div>
              </div>

              {/* Language Switcher */}
              <div className="col-md-3 col-sm-12 d-flex align-items-center justify-content-end">
                {loadingLanguages ? (
                  <div className="d-flex align-items-center">
                    <div
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                    >
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    <span>Loading languages...</span>
                  </div>
                ) : availableLanguages.length > 1 ? (
                  <div className="language-switcher">
                    <div className="dropdown">
                      <button
                        className="btn btn-outline-secondary dropdown-toggle d-flex align-items-center"
                        type="button"
                        id="languageDropdown"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        style={{
                          borderColor: buttonColor,
                          color: buttonColor,
                          backgroundColor: "transparent",
                        }}
                      >
                        <span
                          className={`fi fi-${getLanguageFlag(currentLanguage)} me-2`}
                          style={{ fontSize: "16px" }}
                        ></span>
                        <span className="me-1">
                          {getLanguageName(currentLanguage)}
                        </span>
                        <span
                          className="badge bg-primary ms-1"
                          style={{ backgroundColor: buttonColor }}
                        >
                          {availableLanguages.length}
                        </span>
                      </button>
                      <ul
                        className="dropdown-menu"
                        aria-labelledby="languageDropdown"
                      >
                        {availableLanguages.map((lang) => (
                          <li key={lang}>
                            <button
                              className={`dropdown-item d-flex align-items-center ${currentLanguage === lang ? "active" : ""}`}
                              onClick={() => handleLanguageChange(lang)}
                              style={{
                                backgroundColor:
                                  currentLanguage === lang
                                    ? `${buttonColor}20`
                                    : "transparent",
                              }}
                            >
                              <span
                                className={`fi fi-${getLanguageFlag(lang)} me-2`}
                                style={{ fontSize: "16px" }}
                              ></span>
                              <span>{getLanguageName(lang)}</span>
                              {currentLanguage === lang && (
                                <i className="fas fa-check ms-auto text-success"></i>
                              )}
                            </button>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                ) : (
                  <div className="d-flex align-items-center text-muted">
                    <span
                      className={`fi fi-${getLanguageFlag(currentLanguage)} me-2`}
                      style={{ fontSize: "16px" }}
                    ></span>
                    <span>{getLanguageName(currentLanguage)}</span>
                    <small className="ms-2">(Only language available)</small>
                  </div>
                )}
              </div>

              <div className="col-md-3 col-sm-12" style={{ width: "100%" }}>
                {/* <button type='button' onClick={() => navigate(-1)} style={{ float: "right", backgroundColor: buttonColor }} className="btn btn-success">
                  {`<< Go Back`}
                </button> */}
                {/* <span className="bi bi-gear micon" style={{color:buttonColor}} onClick={() => setIsPanelOpen(!isPanelOpen)}> Menu Buttons Configuration</span> */}

                <div className="col-sm-12 text-end">
                  <button
                    className="btn btn-outline-secondary btn-back-effect"
                    onClick={() => navigate(-1)}
                    style={{
                      "--brand-color": buttonColor,
                    }}
                  >
                    <i className="bi bi-arrow-left me-2"></i>
                    Back
                  </button>
                </div>

                {/* Side Panel */}
                <SlidePanelForm
                  isOpen={isPanelOpen}
                  onClose={() => setIsPanelOpen(false)}
                  onSave={handleSave}
                  buttonColor={{ buttonColor }}
                  userId={id}
                  currentLanguage={currentLanguage}
                />

                {openButtonId && (
                  <ButtonSlidePanelForm
                    isOpen={true} // Only one panel is open at a time
                    onClose={() => setOpenButtonId(null)} // Close panel
                    onSave={handleSaveButton}
                    buttonColor={{ buttonColor }}
                    userId={id}
                    buttonId={openButtonId} // Pass the selected button ID
                  />
                )}
              </div>
            </div>
          </div>
          <div className="dashboard-container">
            <Box sx={{ width: "100%" }}>
              <Tabs
                value={value}
                onChange={handleTabChange}
                aria-label="tab navigation"
                sx={{
                  "& .MuiTab-root": { minWidth: 100 }, // Ensures consistent width
                  "& .Mui-selected": { fontWeight: "bold" }, // Active tab styling
                }}
              >
                <Tab
                  sx={{
                    "&:hover": {
                      backgroundColor: buttonColor, // Add your desired hover color here
                      color: "#fff",
                      fontWeight: "bold",
                    },
                  }}
                  label="Main Menu"
                />
                <Tab
                  sx={{
                    "&:hover": {
                      backgroundColor: buttonColor, // Add your desired hover color here
                      color: "#fff",
                      fontWeight: "bold",
                    },
                  }}
                  label="Main Menu Media"
                />
                <Tab
                  sx={{
                    "&:hover": {
                      backgroundColor: buttonColor, // Add your desired hover color here
                      color: "#fff",
                      fontWeight: "bold",
                    },
                  }}
                  label="Main Menu Text"
                />

                <Tab
                  onClick={() => navigate(`/view-splash-settings/${id}`)}
                  sx={{
                    "&:hover": {
                      backgroundColor: buttonColor, // Add your desired hover color here
                      color: "#fff",
                      fontWeight: "bold",
                    },
                  }}
                  label={"Splash Settings"}
                />
                <Tab
                  onClick={() => navigate(`/global-settings/${id}`)}
                  sx={{
                    "&:hover": {
                      backgroundColor: buttonColor, // Add your desired hover color here
                      color: "#fff",
                      fontWeight: "bold",
                    },
                  }}
                  label={"Global Settings"}
                />

                <Tab
                  onClick={() => navigate(`/availablity-settings/${id}`)}
                  sx={{
                    "&:hover": {
                      backgroundColor: buttonColor, // Add your desired hover color here
                      color: "#fff",
                      fontWeight: "bold",
                    },
                  }}
                  label={"System Settings"}
                />
                <Tab
                  sx={{
                    "&:hover": {
                      backgroundColor: buttonColor, // Add your desired hover color here
                      color: "#fff",
                      fontWeight: "bold",
                    },
                  }}
                  label="Language Translator"
                />

                {/* Conditionally render Wayfinder tab only if enabled */}
                {isWayfinderEnabled && (
                  <Tab
                    onClick={() => navigate(`/wayfinder/${id}`)}
                    sx={{
                      "&:hover": {
                        backgroundColor: buttonColor,
                        color: "#fff",
                        fontWeight: "bold",
                      },
                    }}
                    label="Wayfinder"
                  />
                )}
              </Tabs>
              <Box sx={{ p: 3 }}>
                {value === 0 && !airtableEnabled && (
                  <>
                    <div
                      className="center-container"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop: "35px",
                      }}
                    >
                      <div
                        className="menu-card"
                        style={{ marginRight: "15px" }}
                      >
                        <div className="menu-title">
                          <span>{"Main Menu"}</span>

                          <Link
                            to={`#`}
                            onClick={() => {
                              setIsPanelOpen(!isPanelOpen);
                              setOpenButtonId(null);
                            }}
                          >
                            {" "}
                            <span className="bi bi-gear micon"></span>
                          </Link>

                          <Link to={`#`} onClick={() => handleToggleAirtable()}>
                            <span
                              className="bi bi-table micon"
                              title="Configure Airtable Integration"
                              style={{
                                color: isAirtableEnabled ? "green" : "",
                              }}
                            ></span>
                          </Link>
                        </div>

                        {/* Render Submenus */}
                        <ul
                          className="submenu-list"
                          style={{ minHeight: "119px" }}
                        >
                          {(frontendmainmenu || []).map((submenu) => (
                            <li className="submenu-item" key={submenu._id}>
                              {/* {submenu.name}{" "} */}
                              {/* {truncateText(submenu.name, 20)} */}

                              <span
                                data-tooltip-id={`tooltip-${submenu._id}`}
                                data-tooltip-content={(() => {
                                  const nameText =
                                    typeof submenu.name === "object"
                                      ? submenu.name[currentLanguage] ||
                                      submenu.name["en"] ||
                                      submenu.name[
                                      Object.keys(submenu.name)[0]
                                      ] ||
                                      ""
                                      : submenu.name;
                                  return String(nameText).length > 20
                                    ? String(nameText).replace(
                                      /<br\s*\/?>/gi,
                                      " ",
                                    )
                                    : "";
                                })()}
                              >
                                {truncateText(submenu.name, 20)}{" "}
                                {submenu?.matchedMenuName}
                              </span>
                              {/* <ReactTooltip id={`submenu-${submenu._id}`} place="top" effect="solid" /> */}

                              <Tooltip
                                id={`tooltip-${submenu._id}`}
                                place="top"
                                style={{
                                  backgroundColor: buttonColor,
                                  zIndex: 9999,
                                }}
                                effect="float"
                              />

                              <div>
                                <CalendarScheduler
                                  itemId={submenu._id}
                                  itemName={submenu.name}
                                  buttonColor={buttonColor}
                                  userId={id}
                                  menuName={"Main Menu"}
                                />
                                <Link
                                  to={`/view-global-settings/${submenu._id}/${id}`}
                                >
                                  <span
                                    className="bi bi-gear micon"
                                    title="Button Settings"
                                  ></span>
                                </Link>

                                {submenu.isVisible ? (
                                  <span
                                    className="bi bi-eye micon"
                                    title="Visible"
                                    onClick={() =>
                                      toggleMenuVisibility(
                                        submenu._id,
                                        submenu.isVisible,
                                        true,
                                      )
                                    }
                                  ></span>
                                ) : (
                                  <span
                                    className="bi bi-eye-slash micon"
                                    title="Hidden"
                                    onClick={() =>
                                      toggleMenuVisibility(
                                        submenu._id,
                                        submenu.isVisible,
                                        true,
                                      )
                                    }
                                  ></span>
                                )}

                                <span
                                  className="bi bi-trash micon"
                                  title="Delete"
                                  onClick={() => {
                                    if (
                                      window.confirm(
                                        "Are you sure you want to delete this button?",
                                      )
                                    ) {
                                      deleteMenu(submenu._id, true);
                                    }
                                  }}
                                ></span>
                              </div>
                            </li>
                          ))}
                        </ul>

                        {/* Add Submenu */}
                        <div className="form-group" style={{ display: "flex" }}>
                          <input
                            type="text"
                            placeholder="Enter Button Name"
                            value={frontMainmenuName}
                            onChange={(e) =>
                              setFrontMainMenuName(e.target.value)
                            }
                          />
                          <button
                            style={{ backgroundColor: buttonColor }}
                            className="add-btn"
                            onClick={createFrontMainMenu}
                          >
                            +
                          </button>
                        </div>
                      </div>
                    </div>

                    {/* Button Menu */}

                    {frontendmainmenu.length > 0 && (
                      <div>
                        <div className="form-group" style={{ display: "flex" }}>
                          <input
                            type="text"
                            placeholder="Menu Name"
                            value={menuName}
                            onChange={(e) => setMenuName(e.target.value)}
                          />
                          <button
                            style={{ backgroundColor: buttonColor }}
                            className="add-btn"
                            onClick={createMenu}
                          >
                            +
                          </button>
                        </div>
                      </div>
                    )}

                    {frontendmainmenu &&
                      (menus || []).map((menu) => (
                        <div
                          className="menu-card"
                          key={menu._id}
                          style={{ marginRight: "15px" }}
                        >
                          <div className="menu-title">
                            {/* {truncateText(menu.name, 15)} */}

                            <span
                              data-tooltip-id={`tooltip-${menu._id}`}
                              data-tooltip-content={(() => {
                                const nameText =
                                  typeof menu.name === "object"
                                    ? menu.name[currentLanguage] ||
                                    menu.name["en"] ||
                                    menu.name[Object.keys(menu.name)[0]] ||
                                    ""
                                    : menu.name;
                                return String(nameText).length > 15
                                  ? String(nameText).replace(
                                    /<br\s*\/?>/gi,
                                    " ",
                                  )
                                  : "";
                              })()}
                            >
                              {truncateText(menu.name, 15)}
                            </span>
                            <Tooltip
                              id={`tooltip-${menu._id}`}
                              place="top"
                              style={{
                                backgroundColor: buttonColor,
                                zIndex: 9999,
                              }}
                              effect=""
                            />

                            {menu.isVisible ? (
                              <span
                                className="bi bi-eye micon"
                                onClick={() =>
                                  toggleMenuVisibility(menu._id, menu.isVisible)
                                }
                              ></span>
                            ) : (
                              <span
                                className="bi  bi-eye-slash micon"
                                onClick={() =>
                                  toggleMenuVisibility(menu._id, menu.isVisible)
                                }
                              ></span>
                            )}

                            {/* <Link to={`/view-global-settings/${menu._id}/${id}`}><span className="bi bi-gear micon"></span></Link> */}

                            <Link
                              to={`#`}
                              onClick={() => handleOpenPanel(menu._id)}
                            >
                              <span className="bi bi-gear micon"></span>
                            </Link>

                            <span
                              className="bi bi-trash micon"
                              title="Delete"
                              onClick={() => {
                                if (
                                  window.confirm(
                                    "Are you sure you want to delete this menu?",
                                  )
                                ) {
                                  deleteMenu(menu._id);
                                }
                              }}
                            ></span>
                          </div>

                          {/* Render Submenus */}
                          <ul className="submenu-list">
                            {menu?.submenus?.map((submenu) => (
                              <li className="submenu-item" key={submenu._id}>
                                {/* {submenu.name}{" "} */}
                                {/* {truncateText(submenu.name, 20)} */}

                                <span
                                  data-tooltip-id={`tooltip-${submenu._id}`}
                                  data-tooltip-content={(() => {
                                    const nameText =
                                      typeof submenu.name === "object"
                                        ? submenu.name[currentLanguage] ||
                                        submenu.name["en"] ||
                                        submenu.name[
                                        Object.keys(submenu.name)[0]
                                        ] ||
                                        ""
                                        : submenu.name;
                                    return String(nameText).length > 20
                                      ? String(nameText).replace(
                                        /<br\s*\/?>/gi,
                                        " ",
                                      )
                                      : "";
                                  })()}
                                >
                                  {truncateText(submenu.name, 20)}
                                </span>
                                {/* <ReactTooltip id={`submenu-${submenu._id}`} place="top" effect="solid" /> */}

                                <Tooltip
                                  id={`tooltip-${submenu._id}`}
                                  place="top"
                                  style={{
                                    backgroundColor: buttonColor,
                                    zIndex: 9999,
                                  }}
                                  effect="float"
                                />

                                <div>
                                  <CalendarScheduler
                                    itemId={submenu._id}
                                    itemName={submenu.name}
                                    buttonColor={buttonColor}
                                    userId={id}
                                    menuName={menu.name}
                                  />

                                  <Link
                                    to={`/view-global-settings/${submenu._id}/${id}`}
                                    title="Button Settings"
                                  >
                                    <span className="bi bi-gear micon"></span>
                                  </Link>

                                  {submenu.isVisible ? (
                                    <span
                                      className="bi bi-eye micon"
                                      title="Visible"
                                      onClick={() =>
                                        toggleSubmenuVisibility(
                                          menu._id,
                                          submenu._id,
                                          submenu.isVisible,
                                        )
                                      }
                                    ></span>
                                  ) : (
                                    <span
                                      className="bi bi-eye-slash micon"
                                      title="Hidden"
                                      onClick={() =>
                                        toggleSubmenuVisibility(
                                          menu._id,
                                          submenu._id,
                                          submenu.isVisible,
                                        )
                                      }
                                    ></span>
                                  )}

                                  <span
                                    className="bi bi-trash micon"
                                    title="Delete"
                                    onClick={() => {
                                      if (
                                        window.confirm(
                                          "Are you sure you want to delete this submenu?",
                                        )
                                      ) {
                                        deleteSubmenu(menu._id, submenu._id);
                                      }
                                    }}
                                  ></span>
                                </div>
                              </li>
                            ))}
                          </ul>

                          {/* Add Submenu */}
                          <div style={{ display: "flex" }}>
                            <input
                              type="text"
                              placeholder="Submenu Name"
                              value={submenuNames[menu._id] || ""} // Specific to the current menu
                              onChange={(e) =>
                                handleSubmenuInputChange(
                                  menu._id,
                                  e.target.value,
                                )
                              }
                            />
                            <button
                              style={{ backgroundColor: buttonColor }}
                              className="add-btn"
                              onClick={() => addSubmenu(menu._id)}
                            >
                              +
                            </button>
                          </div>
                        </div>
                      ))}
                  </>
                )}

                {/* Airtable Integration */}
                {value === 0 && airtableEnabled && (
                  <AirtableIntegration
                    userId={id}
                    buttonColor={buttonColor}
                    onBackToMenu={handleBackToMenu}
                  />
                )}

                {value === 1 && (
                  <div>
                    <form
                      className="tab-wizard wizard-circle wizard vertical"
                      onSubmit={handleSubmit}
                    >
                      <div className="row ">
                        {/* Left Top Media */}
                        <div className="col-md-6 d-flex p-3">
                          <div
                            className={`form-group menu-card2 ${!uploadedUrls?.leftTop?.enabled ? "disabled" : ""} h-100 w-100`}
                          >
                            <div className="form-group">
                              <label>Upper Left Media:</label>
                              <ToggleSwitch
                                label="Enable"
                                isOn={uploadedUrls.leftTop.enabled}
                                id={"leftTop"}
                                onChange={(value) =>
                                  handleToggleChangeMedia("leftTop", value)
                                }
                              />
                            </div>

                            <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "1fr 1fr",
                                gap: "5px",
                              }}
                            >
                              <MediaDropzone
                                onDrop={createDropHandler(setLeftTopMedia)}
                                selectedFile={leftTopMedia}
                              />
                              <UploadedUrlImage url={uploadedUrls.leftTop} />
                            </div>

                            <div>
                              <UploadedUrl url={uploadedUrls.leftTop} />
                            </div>

                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                gap: "10px",
                                alignItems: "center",
                                marginTop: "20px",
                              }}
                            >
                              <UploadButton
                                uploading={uploadingStates.leftTop}
                                onUpload={() =>
                                  handleUpload(leftTopMedia, "leftTop")
                                }
                                buttonColor={buttonColor}
                                style={{ margin: "0" }}
                              />

                              <div
                                className="dimensions"
                                style={{
                                  // flex: '1',
                                  display: "flex",
                                  justifyContent: "end",
                                  alignItems: "center",
                                  height: "100%",
                                }}
                              >
                                <div
                                  style={{
                                    width: "60%",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "10px",
                                    height: "100%",
                                  }}
                                >
                                  <label
                                    style={{
                                      fontWeight: "600",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    Size (%):
                                  </label>

                                  <input
                                    style={{ width: "100%" }}
                                    type="number"
                                    value={uploadedUrls.leftTop.width}
                                    onChange={(e) =>
                                      setUploadedUrls({
                                        ...uploadedUrls,
                                        leftTop: {
                                          ...uploadedUrls.leftTop,
                                          width: Number(e.target.value),
                                        },
                                      })
                                    }
                                  />

                                  <label style={{ display: "none" }}>
                                    Height:
                                    <input
                                      type="number"
                                      value={uploadedUrls.leftTop.height}
                                      onChange={(e) =>
                                        setUploadedUrls({
                                          ...uploadedUrls,
                                          leftTop: {
                                            ...uploadedUrls.leftTop,
                                            height: Number(e.target.value),
                                          },
                                        })
                                      }
                                    />
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6 d-flex p-3">
                          <div
                            className={`form-group menu-card2 ${!uploadedUrls?.rightTop?.enabled ? "disabled" : ""
                              } h-100 w-100`}
                          >
                            {/* TOP LABEL + TOGGLE */}
                            <div className="form-group">
                              <label>Right Top Media:</label>
                              <ToggleSwitch
                                label="Enable"
                                isOn={uploadedUrls.rightTop.enabled}
                                id={"rightTop"}
                                onChange={(val) =>
                                  handleToggleChangeMedia("rightTop", val)
                                }
                              />
                            </div>

                            {/* UPLOAD + PREVIEW (GRID LIKE LEFT SIDE) */}
                            <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "1fr 1fr",
                                gap: "5px",
                              }}
                            >
                              <MediaDropzone
                                onDrop={createDropHandler(setRightTopMedia)}
                                selectedFile={rightTopMedia}
                              />

                              {/* If you want same image preview component as left */}
                              <UploadedUrlImage url={uploadedUrls.rightTop} />
                            </div>

                            {/* TEXT URL BLOCK */}
                            <div>
                              <UploadedUrl url={uploadedUrls.rightTop} />
                            </div>

                            {/* BUTTON + DIMENSIONS */}
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                gap: "10px",
                                alignItems: "center",
                                marginTop: "20px",
                              }}
                            >
                              <UploadButton
                                uploading={uploadingStates.rightTop}
                                onUpload={() =>
                                  handleUpload(rightTopMedia, "rightTop")
                                }
                                buttonColor={buttonColor}
                                style={{ margin: "0" }}
                              />

                              <div
                                className="dimensions"
                                style={{
                                  display: "flex",
                                  justifyContent: "end",
                                  alignItems: "center",
                                  height: "100%",
                                }}
                              >
                                <div
                                  style={{
                                    width: "60%",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "10px",
                                    height: "100%",
                                  }}
                                >
                                  <label
                                    style={{
                                      fontWeight: "600",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    Size (%):
                                  </label>

                                  <input
                                    style={{ width: "100%" }}
                                    type="number"
                                    value={uploadedUrls.rightTop.width}
                                    onChange={(e) =>
                                      setUploadedUrls({
                                        ...uploadedUrls,
                                        rightTop: {
                                          ...uploadedUrls.rightTop,
                                          width: Number(e.target.value),
                                        },
                                      })
                                    }
                                  />

                                  <label style={{ display: "none" }}>
                                    Height:
                                    <input
                                      type="number"
                                      value={uploadedUrls.rightTop.height}
                                      onChange={(e) =>
                                        setUploadedUrls({
                                          ...uploadedUrls,
                                          rightTop: {
                                            ...uploadedUrls.rightTop,
                                            height: Number(e.target.value),
                                          },
                                        })
                                      }
                                    />
                                  </label>
                                </div>
                              </div>
                            </div>

                            {/* <small style={{ color: "#000000" }}>
      Note: The <code>height</code> will be set to the same aspect ratio as the
      graphic
    </small> */}
                          </div>
                        </div>
                      </div>

                      <div className="row ">
                        <div className="col-md-6 d-flex p-3">
                          <div
                            className={`form-group menu-card2 ${!uploadedUrls?.leftBottom?.enabled
                                ? "disabled"
                                : ""
                              } h-100 w-100`}
                          >
                            <div className="form-group">
                              <label>Lower Left Media:</label>
                              <ToggleSwitch
                                label="Enable"
                                isOn={uploadedUrls.leftBottom.enabled}
                                id={"leftBottom"}
                                onChange={(value) =>
                                  handleToggleChangeMedia("leftBottom", value)
                                }
                              />
                            </div>

                            <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "1fr 1fr",
                                gap: "5px",
                              }}
                            >
                              <MediaDropzone
                                onDrop={createDropHandler(setLeftBottomMedia)}
                                selectedFile={leftBottomMedia}
                              />
                              <UploadedUrlImage url={uploadedUrls.leftBottom} />
                            </div>

                            <div>
                              <UploadedUrl url={uploadedUrls.leftBottom} />
                            </div>

                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                gap: "10px",
                                alignItems: "center",
                                marginTop: "20px",
                              }}
                            >
                              <UploadButton
                                uploading={uploadingStates.leftBottom}
                                onUpload={() =>
                                  handleUpload(leftBottomMedia, "leftBottom")
                                }
                                buttonColor={buttonColor}
                                style={{ margin: "0" }}
                              />

                              <div
                                className="dimensions"
                                style={{
                                  // flex: '1',
                                  display: "flex",
                                  justifyContent: "end",
                                  alignItems: "center",
                                  height: "100%",
                                }}
                              >
                                <div
                                  style={{
                                    width: "60%",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "10px",
                                    height: "100%",
                                  }}
                                >
                                  <label
                                    style={{
                                      fontWeight: "600",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    Size (%):
                                  </label>
                                  <input
                                    style={{ width: "100%" }}
                                    type="number"
                                    value={uploadedUrls.leftBottom.width}
                                    onChange={(e) =>
                                      setUploadedUrls({
                                        ...uploadedUrls,
                                        leftBottom: {
                                          ...uploadedUrls.leftBottom,
                                          width: Number(e.target.value),
                                        },
                                      })
                                    }
                                  />

                                  <label style={{ display: "none" }}>
                                    Height:
                                    <input
                                      type="number"
                                      value={uploadedUrls.leftBottom.height}
                                      onChange={(e) =>
                                        setUploadedUrls({
                                          ...uploadedUrls,
                                          leftBottom: {
                                            ...uploadedUrls.leftBottom,
                                            height: Number(e.target.value),
                                          },
                                        })
                                      }
                                    />
                                  </label>
                                </div>
                              </div>
                            </div>
                            {/* <small style={{ color: "#000000" }}>
      Note: The <code>height</code> will be set to the same aspect ratio as the
      graphic
    </small> */}
                          </div>
                        </div>

                        <div className="col-md-6 d-flex p-3">
                          <div
                            className={`form-group menu-card2 ${!uploadedUrls?.rightBottom?.enabled
                                ? "disabled"
                                : ""
                              } h-100 w-100`}
                          >
                            <div className="form-group">
                              <label>Lower Right Media:</label>
                              <ToggleSwitch
                                label="Enable"
                                isOn={uploadedUrls.rightBottom.enabled}
                                id={"rightBottom"}
                                onChange={(value) =>
                                  handleToggleChangeMedia("rightBottom", value)
                                }
                              />
                            </div>

                            <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "1fr 1fr",
                                gap: "5px",
                              }}
                            >
                              <MediaDropzone
                                onDrop={createDropHandler(setRightBottomMedia)}
                                selectedFile={rightBottomMedia}
                              />
                              <UploadedUrlImage
                                url={uploadedUrls.rightBottom}
                              />
                            </div>

                            <div>
                              <UploadedUrl url={uploadedUrls.rightBottom} />
                            </div>

                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                gap: "10px",
                                alignItems: "center",
                                marginTop: "20px",
                              }}
                            >
                              <UploadButton
                                uploading={uploadingStates.rightBottom}
                                onUpload={() =>
                                  handleUpload(rightBottomMedia, "rightBottom")
                                }
                                buttonColor={buttonColor}
                                style={{ margin: "0" }}
                              />

                              <div
                                className="dimensions"
                                style={{
                                  display: "flex",
                                  justifyContent: "end",
                                  alignItems: "center",
                                  height: "100%",
                                }}
                              >
                                <div
                                  style={{
                                    width: "60%",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "10px",
                                    height: "100%",
                                  }}
                                >
                                  <label
                                    style={{
                                      fontWeight: "600",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    Size (%):
                                  </label>

                                  <input
                                    style={{ width: "100%" }}
                                    type="number"
                                    value={uploadedUrls.rightBottom.width}
                                    onChange={(e) =>
                                      setUploadedUrls({
                                        ...uploadedUrls,
                                        rightBottom: {
                                          ...uploadedUrls.rightBottom,
                                          width: Number(e.target.value),
                                        },
                                      })
                                    }
                                  />

                                  <label style={{ display: "none" }}>
                                    Height:
                                    <input
                                      type="number"
                                      value={uploadedUrls.rightBottom.height}
                                      onChange={(e) =>
                                        setUploadedUrls({
                                          ...uploadedUrls,
                                          rightBottom: {
                                            ...uploadedUrls.rightBottom,
                                            height: Number(e.target.value),
                                          },
                                        })
                                      }
                                    />
                                  </label>
                                </div>
                              </div>
                            </div>

                            {/* <small style={{ color: '#000000' }}>
                              Note: The <code>height</code> will be set to the same aspect ratio as
                              the graphic
                            </small> */}
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-6 d-flex p-3">
                          <div
                            className={`form-group menu-card2 ${!uploadedUrls?.centerBelowMenuMedia?.enabled
                                ? "disabled"
                                : ""
                              } h-100 w-100`}
                          >
                            {/* LABEL + TOGGLE */}
                            <div className="form-group">
                              <label>Lower Center Menu Media</label>
                              <ToggleSwitch
                                label="Enable"
                                isOn={uploadedUrls.centerBelowMenuMedia.enabled}
                                id={"centerBelowMenuMedia"}
                                onChange={(value) =>
                                  handleToggleChangeMedia(
                                    "centerBelowMenuMedia",
                                    value,
                                  )
                                }
                              />
                            </div>

                            {/* GRID DROPZONE + PREVIEW */}
                            <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "1fr 1fr",
                                gap: "5px",
                              }}
                            >
                              <MediaDropzone
                                onDrop={createDropHandler(
                                  setCenterBelowMenuMedia,
                                )}
                                selectedFile={centerBelowMenuMedia}
                              />
                              <UploadedUrlImage
                                url={uploadedUrls.centerBelowMenuMedia}
                              />
                            </div>

                            {/* TEXT URL */}
                            <div>
                              <UploadedUrl
                                url={uploadedUrls.centerBelowMenuMedia}
                              />
                            </div>

                            {/* BUTTON + DIMENSIONS */}
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                gap: "10px",
                                alignItems: "center",
                                marginTop: "20px",
                              }}
                            >
                              <UploadButton
                                uploading={uploadingStates.centerBelowMenuMedia}
                                onUpload={() =>
                                  handleUpload(
                                    centerBelowMenuMedia,
                                    "centerBelowMenuMedia",
                                  )
                                }
                                buttonColor={buttonColor}
                                style={{ margin: "0" }}
                              />

                              <div
                                className="dimensions"
                                style={{
                                  display: "flex",
                                  justifyContent: "end",
                                  alignItems: "center",
                                  height: "100%",
                                }}
                              >
                                <div
                                  style={{
                                    width: "60%",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "10px",
                                    height: "100%",
                                  }}
                                >
                                  <label
                                    style={{
                                      fontWeight: "600",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    Size (%):
                                  </label>

                                  <input
                                    style={{ width: "100%" }}
                                    type="number"
                                    value={
                                      uploadedUrls.centerBelowMenuMedia.width
                                    }
                                    onChange={(e) =>
                                      setUploadedUrls({
                                        ...uploadedUrls,
                                        centerBelowMenuMedia: {
                                          ...uploadedUrls.centerBelowMenuMedia,
                                          width: Number(e.target.value),
                                        },
                                      })
                                    }
                                  />

                                  <label style={{ display: "none" }}>
                                    Height:
                                    <input
                                      type="number"
                                      value={
                                        uploadedUrls.centerBelowMenuMedia.height
                                      }
                                      onChange={(e) =>
                                        setUploadedUrls({
                                          ...uploadedUrls,
                                          centerBelowMenuMedia: {
                                            ...uploadedUrls.centerBelowMenuMedia,
                                            height: Number(e.target.value),
                                          },
                                        })
                                      }
                                    />
                                  </label>
                                </div>
                              </div>
                            </div>

                            {/* <small style={{ color: "#000000" }}>
      Note: The <code>height</code> will match the graphic’s aspect ratio.
    </small> */}
                          </div>
                        </div>{" "}
                        <div className="col-md-6 d-flex p-3">
                          <div
                            className={`form-group menu-card2 ${!uploadedUrls?.centerLogo?.enabled
                                ? "disabled"
                                : ""
                              } h-100 w-100`}
                          >
                            {/* LABEL + TOGGLE */}
                            <div className="form-group">
                              <label>Center Logo:</label>
                              <ToggleSwitch
                                label="Enable"
                                isOn={uploadedUrls.centerLogo.enabled}
                                id={"centerLogo"}
                                onChange={(value) =>
                                  handleToggleChangeMedia("centerLogo", value)
                                }
                              />
                            </div>

                            {/* GRID DROPZONE + PREVIEW */}
                            <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "1fr 1fr",
                                gap: "5px",
                              }}
                            >
                              <MediaDropzone
                                onDrop={createDropHandler(setCenterLogoMedia)}
                                selectedFile={centerLogoMedia}
                              />
                              <UploadedUrlImage url={uploadedUrls.centerLogo} />
                            </div>

                            {/* TEXT URL */}
                            <div>
                              <UploadedUrl url={uploadedUrls.centerLogo} />
                            </div>

                            {/* BUTTON + DIMENSIONS */}
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                gap: "10px",
                                alignItems: "center",
                                marginTop: "20px",
                              }}
                            >
                              <UploadButton
                                uploading={uploadingStates.centerLogo}
                                onUpload={() =>
                                  handleUpload(centerLogoMedia, "centerLogo")
                                }
                                buttonColor={buttonColor}
                                style={{ margin: "0" }}
                              />

                              <div
                                className="dimensions"
                                style={{
                                  display: "flex",
                                  justifyContent: "end",
                                  alignItems: "center",
                                  height: "100%",
                                }}
                              >
                                <div
                                  style={{
                                    width: "60%",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "10px",
                                    height: "100%",
                                  }}
                                >
                                  <label
                                    style={{
                                      fontWeight: "600",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    Size (%):
                                  </label>

                                  <input
                                    style={{ width: "100%" }}
                                    type="number"
                                    value={uploadedUrls.centerLogo.width}
                                    onChange={(e) =>
                                      setUploadedUrls({
                                        ...uploadedUrls,
                                        centerLogo: {
                                          ...uploadedUrls.centerLogo,
                                          width: Number(e.target.value),
                                        },
                                      })
                                    }
                                  />

                                  <label style={{ display: "none" }}>
                                    Height:
                                    <input
                                      type="number"
                                      value={uploadedUrls.centerLogo.height}
                                      onChange={(e) =>
                                        setUploadedUrls({
                                          ...uploadedUrls,
                                          centerLogo: {
                                            ...uploadedUrls.centerLogo,
                                            height: Number(e.target.value),
                                          },
                                        })
                                      }
                                    />
                                  </label>
                                </div>
                              </div>
                            </div>

                            {/* <small style={{ color: "#000000" }}>
                                 Note: The <code>height</code> will match the graphic’s aspect ratio.
                             </small> */}
                          </div>
                        </div>
                      </div>

                      <div className="row ">
                        <div className="col-md-6 d-flex p-3">
                          <div
                            className={`form-group menu-card2 ${!uploadedUrls?.splashVideo?.enabled
                                ? "disabled"
                                : ""
                              } h-100 w-100`}
                          >
                            <div className="form-group">
                              <label>Menu Page Video 1:</label>
                              <ToggleSwitch
                                label="Enable"
                                isOn={uploadedUrls.splashVideo.enabled}
                                id={"splashVideo"}
                                onChange={(val) =>
                                  handleToggleChangeMedia("splashVideo", val)
                                }
                              />
                            </div>

                            <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "1fr 1fr",
                                gap: "5px",
                              }}
                            >
                              <MediaDropzone
                                onDrop={createDropHandler(setSplashVideoMedia)}
                                selectedFile={splashVideoMedia}
                              />

                              <UploadedUrlImage
                                url={uploadedUrls.splashVideo}
                              />
                            </div>

                            <div>
                              <UploadedUrl url={uploadedUrls.splashVideo} />
                            </div>

                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "flex-end",
                                marginTop: "10px",
                              }}
                            >
                              <UploadButton
                                uploading={uploadingStates.splashVideo}
                                onUpload={() =>
                                  handleUpload(splashVideoMedia, "splashVideo")
                                }
                                buttonColor={buttonColor}
                              />

                              <div
                                style={{
                                  marginTop: "10px",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "10px",
                                }}
                              >
                                <button
                                  type="button"
                                  onClick={() =>
                                    openCaptionModal("splashVideo")
                                  }
                                  style={{
                                    backgroundColor: buttonColor,
                                    color: "#ffffffff",
                                    border: "1px solid #ddd",
                                    borderRadius: "4px",
                                    padding: "6px 12px",
                                    cursor: "pointer",
                                    fontSize: "15px",
                                  }}
                                >
                                  {uploadedUrls.splashVideo.captionFile
                                    ? "Manage Captions"
                                    : "Upload Captions"}
                                </button>

                                {uploadedUrls.splashVideo.captionFile && (
                                  <span
                                    style={{
                                      fontSize: "15px",
                                      color: "#252725ff",
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "4px",
                                      fontWeight: "700",
                                    }}
                                  >
                                    <i className="bi bi-cc-circle"></i>
                                    Captions Available
                                  </span>
                                )}

                                {/* Modal for video 1 */}
                                <CaptionUploadModal
                                  isOpen={modalStates.splashVideo}
                                  onClose={() =>
                                    closeCaptionModal("splashVideo")
                                  }
                                  onUpload={(captionFile, convertSrtToVtt) =>
                                    handleCaptionUpload(
                                      captionFile,
                                      convertSrtToVtt,
                                      "splashVideo",
                                    )
                                  }
                                  existingCaptionUrl={
                                    uploadedUrls.splashVideo.captionFile
                                  }
                                  buttonColor={buttonColor}
                                  showMsgSuccessToast={showMsgSuccessToast}
                                  showErrorToast={showErrorToast}
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6 d-flex p-3">
                          <div
                            className={`form-group menu-card2 ${!uploadedUrls?.splashVideotwo?.enabled
                                ? "disabled"
                                : ""
                              } h-100 w-100`}
                          >
                            <div className="form-group">
                              <label>Menu Page Video 2:</label>
                              <ToggleSwitch
                                label="Enable"
                                isOn={uploadedUrls.splashVideotwo.enabled}
                                id={"splashVideotwo"}
                                onChange={(val) =>
                                  handleToggleChangeMedia("splashVideotwo", val)
                                }
                              />
                            </div>

                            <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "1fr 1fr",
                                gap: "5px",
                              }}
                            >
                              <MediaDropzone
                                onDrop={createDropHandler(
                                  setSplashVideoMediaTwo,
                                )}
                                selectedFile={splashVideoMediaTwo}
                              />

                              <UploadedUrlImage
                                url={uploadedUrls.splashVideotwo}
                              />
                            </div>

                            <div>
                              <UploadedUrl url={uploadedUrls.splashVideotwo} />
                            </div>

                            <div
                              style={{
                                marginTop: "10px",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "flex-end",
                              }}
                            >
                              <UploadButton
                                uploading={uploadingStates.splashVideotwo}
                                onUpload={() =>
                                  handleUpload(
                                    splashVideoMediaTwo,
                                    "splashVideotwo",
                                  )
                                }
                                buttonColor={buttonColor}
                              />

                              <div
                                style={{
                                  marginTop: "10px",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "10px",
                                }}
                              >
                                <button
                                  type="button"
                                  onClick={() =>
                                    openCaptionModal("splashVideotwo")
                                  }
                                  style={{
                                    backgroundColor: buttonColor,
                                    color: "#ffffffff",
                                    border: "1px solid #ddd",
                                    borderRadius: "4px",
                                    padding: "6px 12px",
                                    cursor: "pointer",
                                    fontSize: "15px",
                                  }}
                                >
                                  {uploadedUrls.splashVideotwo.captionFile
                                    ? "Manage Captions"
                                    : "Upload Captions"}
                                </button>

                                {uploadedUrls.splashVideotwo.captionFile && (
                                  <span
                                    style={{
                                      fontSize: "15px",
                                      color: "#252725ff",
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "4px",
                                      fontWeight: "700",
                                    }}
                                  >
                                    <i className="bi bi-cc-circle"></i>
                                    Captions Available
                                  </span>
                                )}

                                {/* Modal for video 2 */}
                                <CaptionUploadModal
                                  isOpen={modalStates.splashVideotwo}
                                  onClose={() =>
                                    closeCaptionModal("splashVideotwo")
                                  }
                                  onUpload={(captionFile, convertSrtToVtt) =>
                                    handleCaptionUpload(
                                      captionFile,
                                      convertSrtToVtt,
                                      "splashVideotwo",
                                    )
                                  }
                                  existingCaptionUrl={
                                    uploadedUrls.splashVideotwo.captionFile
                                  }
                                  buttonColor={buttonColor}
                                  showMsgSuccessToast={showMsgSuccessToast}
                                  showErrorToast={showErrorToast}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-6 d-flex p-3">
                          <div
                            className={`form-group menu-card2 ${!uploadedUrls?.splashVideothree?.enabled ? "disabled" : ""}`}
                            style={{
                              height: "auto",
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "space-around",
                              gap: "15px",
                            }}
                          >
                            <div className="form-group">
                              {" "}
                              <label>Menu Page Video 3:</label>
                              <ToggleSwitch
                                label="Enable"
                                isOn={uploadedUrls.splashVideothree.enabled}
                                onChange={(val) =>
                                  handleToggleChangeMedia(
                                    "splashVideothree",
                                    val,
                                  )
                                }
                                id={"splashVideothree"}
                              />
                            </div>

                            {/* DROPZONE + PREVIEW */}
                            <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "1fr 1fr",
                                gap: "5px",
                              }}
                            >
                              {" "}
                              <MediaDropzone
                                onDrop={createDropHandler(
                                  setSplashVideoMediaThree,
                                )}
                                selectedFile={splashVideoMediaThree}
                              />{" "}
                              <UploadedUrlImage
                                url={uploadedUrls.splashVideothree}
                              />
                            </div>

                            <UploadedUrl url={uploadedUrls.splashVideothree} />

                            <div
                              style={{
                                marginTop: "10px",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "flex-end",
                              }}
                            >
                              <UploadButton
                                uploading={uploadingStates.splashVideothree}
                                onUpload={() =>
                                  handleUpload(
                                    splashVideoMediaThree,
                                    "splashVideothree",
                                  )
                                }
                                buttonColor={buttonColor}
                              />

                              <div
                                style={{
                                  marginTop: "10px",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "10px",
                                }}
                              >
                                <button
                                  type="button"
                                  onClick={() =>
                                    openCaptionModal("splashVideothree")
                                  }
                                  style={{
                                    backgroundColor: buttonColor,
                                    color: "#ffffffff",
                                    border: "1px solid #ddd",
                                    borderRadius: "4px",
                                    padding: "6px 12px",
                                    cursor: "pointer",
                                    fontSize: "15px",
                                  }}
                                >
                                  {uploadedUrls.splashVideothree.captionFile
                                    ? "Manage Captions"
                                    : "Upload Captions"}
                                </button>

                                {uploadedUrls.splashVideothree.captionFile && (
                                  <span
                                    style={{
                                      fontSize: "15px",
                                      color: "#252725ff",
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "4px",
                                      fontWeight: "700",
                                    }}
                                  >
                                    <i className="bi bi-cc-circle"></i>
                                    Captions Available
                                  </span>
                                )}

                                {/* Modal for video 3 */}
                                <CaptionUploadModal
                                  isOpen={modalStates.splashVideothree}
                                  onClose={() =>
                                    closeCaptionModal("splashVideothree")
                                  }
                                  onUpload={(captionFile, convertSrtToVtt) =>
                                    handleCaptionUpload(
                                      captionFile,
                                      convertSrtToVtt,
                                      "splashVideothree",
                                    )
                                  }
                                  existingCaptionUrl={
                                    uploadedUrls.splashVideothree.captionFile
                                  }
                                  buttonColor={buttonColor}
                                  showMsgSuccessToast={showMsgSuccessToast}
                                  showErrorToast={showErrorToast}
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6 d-flex p-3">
                          <div
                            className={`form-group menu-card2 ${!uploadedUrls?.menuBackButton?.enabled
                                ? "disabled"
                                : ""
                              } h-100 w-100`}
                            style={{
                              height: "auto",
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "space-around",
                              gap: "15px",
                            }}
                          >
                            {/* LABEL + TOGGLE */}
                            <div className="form-group">
                              <label>Back Menu Media:</label>
                              <ToggleSwitch
                                label="Enable"
                                isOn={uploadedUrls.menuBackButton.enabled}
                                onChange={(val) =>
                                  handleToggleChangeMedia("menuBackButton", val)
                                }
                                id="menuBackButton"
                              />
                            </div>

                            {/* DROPZONE + PREVIEW (SIDE-BY-SIDE) */}
                            <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "1fr 1fr",
                                gap: "5px",
                              }}
                            >
                              <MediaDropzone
                                onDrop={createDropHandler(setMenuBackButton)}
                                selectedFile={menuBackButton}
                              />

                              <UploadedUrlImage
                                url={uploadedUrls.menuBackButton}
                              />
                            </div>

                            {/* URL TEXT BELOW */}
                            <UploadedUrl url={uploadedUrls.menuBackButton} />

                            {/* UPLOAD BUTTON */}
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                gap: "10px",
                                alignItems: "center",
                                marginTop: "20px",
                              }}
                            >
                              <UploadButton
                                uploading={uploadingStates.menuBackButton}
                                onUpload={() =>
                                  handleUpload(menuBackButton, "menuBackButton")
                                }
                                buttonColor={buttonColor}
                              />
                              <div
                                className="dimensions"
                                style={{
                                  display: "flex",
                                  justifyContent: "end",
                                  alignItems: "center",
                                  height: "100%",
                                }}
                              >
                                <div
                                  style={{
                                    width: "60%",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "10px",
                                    height: "100%",
                                  }}
                                >
                                  <label
                                    style={{
                                      fontWeight: "600",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    Size (%):
                                  </label>

                                  <input
                                    style={{ width: "100%" }}
                                    type="number"
                                    value={uploadedUrls.menuBackButton.width}
                                    onChange={(e) =>
                                      setUploadedUrls({
                                        ...uploadedUrls,
                                        menuBackButton: {
                                          ...uploadedUrls.menuBackButton,
                                          width: Number(e.target.value),
                                        },
                                      })
                                    }
                                  />

                                  <label style={{ display: "none" }}>
                                    Height:
                                    <input
                                      type="number"
                                      value={uploadedUrls.menuBackButton.height}
                                      onChange={(e) =>
                                        setUploadedUrls({
                                          ...uploadedUrls,
                                          menuBackButton: {
                                            ...uploadedUrls.menuBackButton,
                                            height: Number(e.target.value),
                                          },
                                        })
                                      }
                                    />
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-6 ">
                          <div className="form-group menu-card2">
                            <label>Menu Text:</label>
                            <input
                              type="text"
                              value={splashText}
                              onChange={(e) => setSplashText(e.target.value)}
                              placeholder="Enter splash text"
                              className="form-control"
                            />
                          </div>
                        </div>

                        <div className="col-md-6 ">
                          <div className="form-group menu-card2">
                            <label>
                              How Many Time Video repeat (0 for forever):
                            </label>
                            <input
                              type="number"
                              value={videotime}
                              onChange={(e) =>
                                setVideoTime(Number(e.target.value))
                              }
                              placeholder="Enter Video Time"
                              className="form-control"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-6">
                          <button
                            style={{ backgroundColor: buttonColor }}
                            type="submit"
                            onClick={handleSubmit}
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                )}
                {value === 2 && (
                  <>
                    <div
                      className="row"
                      style={{ marginBottom: "40px", marginTop: "30px" }}
                    >
                      <div className="col-md-12">
                        <div className="col-md-8" style={{ float: "left" }}>
                          <SplashText
                            text={splashText || "Splash Text"}
                            settings={settings?.globalSettings}
                          />
                        </div>

                        <div className="col-md-4" style={{ float: "right" }}>
                          <div className="form-group">
                            <ToggleSwitch
                              label="Customize Global Settings"
                              isOn={settings.enabled}
                              onChange={handleToggleChange}
                              id="menusettings"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    {settings?.enabled && (
                      <div className="global-section">
                        {/* Global Settings */}

                        <form
                          className="tab-wizard wizard-circle wizard vertical"
                          onSubmit={handleSubmit}
                        >
                          <div className="row menu-card2">
                            <div className="col-md-4">
                              <div className="form-group">
                                <label>Height:</label>
                                <input
                                  type="number"
                                  value={settings?.globalSettings?.height ?? 0}
                                  onChange={(e) =>
                                    handleChange(
                                      "height",
                                      Number(e.target.value),
                                    )
                                  }
                                  className="form-control"
                                />
                              </div>
                            </div>

                            <div className="col-md-4">
                              <div className="form-group">
                                <label>Width %:</label>
                                <input
                                  type="number"
                                  value={settings?.globalSettings?.width ?? 0}
                                  onChange={(e) =>
                                    handleChange(
                                      "width",
                                      Number(e.target.value),
                                    )
                                  }
                                  className="form-control"
                                />
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label>
                                  Text Alignment (left centre or right):
                                </label>

                                <select
                                  id="textAlign"
                                  value={
                                    settings?.globalSettings?.textAlign ||
                                    "left"
                                  }
                                  onChange={(e) =>
                                    handleChange("textAlign", e.target.value)
                                  }
                                  className="form-select form-control"
                                >
                                  <option value="left">Left</option>
                                  <option value="center">Center</option>
                                  <option value="right">Right</option>
                                </select>
                              </div>
                            </div>
                          </div>

                          {/* Fill Color */}
                          <div className="row menu-card2">
                            <div className="col-md-4">
                              <div className="form-group">
                                <label>Font Family:</label>

                                <select
                                  id="font"
                                  value={
                                    settings?.globalSettings?.font || "Arial"
                                  }
                                  onChange={(e) =>
                                    handleChange("font", e.target.value)
                                  }
                                  className="form-select form-control"
                                >
                                  {fontOptions}
                                </select>
                              </div>
                            </div>

                            <div className="col-md-4">
                              <div className="form-group">
                                <label
                                  className="d-flex align-items-center"
                                  style={{ height: "25px" }}
                                >
                                  Font color: (Transparent
                                  <input
                                    type="checkbox"
                                    className="ml-1 mr-1"
                                    checked={
                                      settings?.globalSettings?.fontColor ===
                                      "transparent"
                                    }
                                    onChange={(e) =>
                                      handleChange(
                                        "fontColor",
                                        e.target.checked
                                          ? "transparent"
                                          : "#00000",
                                      )
                                    }
                                  />
                                  )
                                </label>

                                <MuiColorInput
                                  className="form-control"
                                  format="hex"
                                  value={
                                    settings?.globalSettings?.fontColor ||
                                    "#000000"
                                  }
                                  onChange={(newHex) =>
                                    handleChange(
                                      "fontColor",
                                      newHex?.toUpperCase?.(),
                                    )
                                  }
                                  fallbackValue="#000000"
                                  disabled={
                                    settings?.globalSettings?.fontColor ===
                                    "transparent"
                                  }
                                  // size="small"
                                  isAlphaHidden={true} // This disables the alpha slider
                                  sx={{
                                    "& .MuiOutlinedInput-root": {
                                      borderRadius: "0px !important",
                                      height: 53,
                                    },
                                    "& .MuiOutlinedInput-input": {
                                      height: "36px",
                                    },
                                    "& .MuiColorInput-Button": {
                                      width: "49px !important", // Increase width
                                      height: "40px !important",
                                    },
                                    "& .MuiInputAdornment-root .MuiBox-root": {
                                      width: 18,
                                      height: 18,
                                    },
                                  }}
                                />

                                {/* <input
                                  type="color"
                                  disabled={settings?.globalSettings?.fontColor === "transparent"}
                                  value={
                                    settings?.globalSettings?.fontColor || "#000000"
                                  }
                                  onChange={(e) => handleChange('fontColor', e.target.value)}
                                  className="form-control"
                                /> */}
                              </div>
                            </div>

                            <div className="col-md-4">
                              <div className="form-group">
                                <label>Font Size:</label>
                                <input
                                  type="number"
                                  value={
                                    settings?.globalSettings?.fontSize || ""
                                  }
                                  onChange={(e) =>
                                    handleChange(
                                      "fontSize",
                                      Number(e.target.value),
                                    )
                                  }
                                  className="form-control"
                                />
                              </div>
                            </div>
                          </div>

                          {/* Shadow Settings */}

                          <div className="row menu-card2">
                            <div className="col-md-3">
                              <div className="form-group">
                                <label>Shadow angle:</label>
                                <input
                                  type="number"
                                  className="form-control"
                                  value={
                                    settings?.globalSettings?.shadow?.angle ?? 0
                                  }
                                  onChange={(e) =>
                                    handleChange(
                                      "shadow.angle",
                                      Number(e.target.value),
                                    )
                                  }
                                />
                              </div>
                            </div>

                            <div className="col-md-3">
                              <div className="form-group">
                                <label>Shadow size:</label>
                                <input
                                  type="number"
                                  value={
                                    settings?.globalSettings?.shadow?.size ?? 0
                                  }
                                  onChange={(e) =>
                                    handleChange(
                                      "shadow.size",
                                      Number(e.target.value),
                                    )
                                  }
                                  className="form-control"
                                />
                              </div>
                            </div>

                            <div className="col-md-3">
                              <div className="form-group">
                                <label>Shadow distance:</label>
                                <input
                                  type="number"
                                  value={
                                    settings?.globalSettings?.shadow
                                      ?.distance ?? 0
                                  }
                                  onChange={(e) =>
                                    handleChange(
                                      "shadow.distance",
                                      Number(e.target.value),
                                    )
                                  }
                                  className="form-control"
                                />
                              </div>
                            </div>

                            <div className="col-md-3">
                              <div className="form-group">
                                <label>Shadow Alpha:</label>
                                <input
                                  type="number"
                                  value={
                                    settings?.globalSettings?.shadow?.alpha ?? 0
                                  }
                                  onChange={(e) =>
                                    handleChange(
                                      "shadow.alpha",
                                      Number(e.target.value),
                                    )
                                  }
                                  className="form-control"
                                />
                              </div>
                            </div>
                          </div>

                          <div className="row menu-card2">
                            <div className="col-md-6">
                              <div className="form-group">
                                <label
                                  className="d-flex align-items-center"
                                  style={{ height: "25px" }}
                                >
                                  Shadow color: (Transparent
                                  <input
                                    type="checkbox"
                                    className="ml-1 mr-1"
                                    checked={
                                      settings?.globalSettings?.shadow
                                        ?.color === "transparent"
                                    }
                                    onChange={(e) =>
                                      handleChange(
                                        "shadow.color",
                                        e.target.checked
                                          ? "transparent"
                                          : "#00000",
                                      )
                                    }
                                  />
                                  )
                                </label>

                                <MuiColorInput
                                  className="form-control"
                                  format="hex"
                                  value={
                                    settings?.globalSettings?.shadow?.color ||
                                    "#000000"
                                  }
                                  onChange={(newHex) =>
                                    handleChange(
                                      "shadow.color",
                                      newHex?.toUpperCase?.(),
                                    )
                                  }
                                  fallbackValue="#000000"
                                  disabled={
                                    settings?.globalSettings?.shadow?.color ===
                                    "transparent"
                                  } // Disable when transparent
                                  // size="small"
                                  isAlphaHidden={true} // This disables the alpha slider
                                  sx={{
                                    "& .MuiOutlinedInput-root": {
                                      borderRadius: "0px !important",
                                      height: 53,
                                    },
                                    "& .MuiOutlinedInput-input": {
                                      height: "36px",
                                    },
                                    "& .MuiColorInput-Button": {
                                      width: "49px !important", // Increase width
                                      height: "40px !important",
                                    },
                                    "& .MuiInputAdornment-root .MuiBox-root": {
                                      width: 18,
                                      height: 18,
                                    },
                                  }}
                                />

                                {/* <input
                                  type="color"
                                  disabled={settings?.globalSettings?.shadow?.color === "transparent"} // Disable when transparent
                                  value={
                                    settings?.globalSettings?.shadow?.color || "#000000"
                                  }
                                  onChange={(e) => handleChange('shadow.color', e.target.value)}
                                  className="form-control"
                                /> */}
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="form-group">
                                <label
                                  className="d-flex align-items-center"
                                  style={{ height: "25px" }}
                                >
                                  Highlight Font color: (Transparent
                                  <input
                                    type="checkbox"
                                    className="ml-1 mr-1"
                                    checked={
                                      settings?.globalSettings?.highlight
                                        ?.fontColor === "transparent"
                                    }
                                    onChange={(e) =>
                                      handleChange(
                                        "highlight.fontColor",
                                        e.target.checked
                                          ? "transparent"
                                          : "#00000",
                                      )
                                    }
                                  />
                                  )
                                </label>
                                <MuiColorInput
                                  className="form-control"
                                  format="hex"
                                  value={
                                    settings?.globalSettings?.highlight
                                      ?.fontColor || "#000000"
                                  }
                                  onChange={(newHex) =>
                                    handleChange(
                                      "highlight.fontColor",
                                      newHex?.toUpperCase?.(),
                                    )
                                  }
                                  fallbackValue="#000000"
                                  disabled={
                                    settings?.globalSettings?.highlight
                                      ?.fontColor === "transparent"
                                  } // Disable when transparent
                                  // size="small"
                                  isAlphaHidden={true} // This disables the alpha slider
                                  sx={{
                                    "& .MuiOutlinedInput-root": {
                                      borderRadius: "0px !important",
                                      height: 53,
                                    },
                                    "& .MuiOutlinedInput-input": {
                                      height: "36px",
                                    },
                                    "& .MuiColorInput-Button": {
                                      width: "49px !important", // Increase width
                                      height: "40px !important",
                                    },
                                    "& .MuiInputAdornment-root .MuiBox-root": {
                                      width: 18,
                                      height: 18,
                                    },
                                  }}
                                />

                                {/* <input
                                  type="color"
                                  className="form-control"
                                  disabled={settings?.globalSettings?.highlight?.fontColor === "transparent"} // Disable when transparent
                                  value={
                                    settings?.globalSettings?.highlight?.fontColor || "#000000"
                                  }
                                  onChange={(e) => handleChange('highlight.fontColor', e.target.value)}
                                /> */}
                              </div>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-md-6">
                              <button
                                style={{ backgroundColor: buttonColor }}
                                type="submit"
                                onClick={handleSubmit}
                              >
                                Submit
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    )}
                  </>
                )}

                {value === 3 && <SplashContent />}

                {value === 6 && (
                  <>
                    <div
                      className="row"
                      style={{ marginBottom: "40px", marginTop: "30px" }}
                    >
                      <div className="col-md-12">
                        <LanguageSelector
                          userId={id}
                          buttonColor={buttonColor}
                        />
                      </div>
                    </div>
                  </>
                )}
              </Box>
            </Box>
          </div>
        </div>
      </div>
      <style jsx>{`
        .btn-back-effect {
          border: 1px solid #6c757d !important;
          color: #6c757d !important;
          background-color: transparent !important;
          border-radius: 8px !important;
        }

        .btn-back-effect:hover {
          background-color: var(--brand-color) !important;
          color: #fff !important;
          border-color: var(--brand-color) !important;
        }
      `}</style>
    </div>
  );
}

// MediaDropzone Component
const MediaDropzone = ({ onDrop, selectedFile }) => {
  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: {
      "image/*": [".jpeg", ".jpg", ".png", ".gif"],
      "video/*": [".mp4", ".mov", ".mp3"],
      "application/pdf": [".pdf"],
    },
    multiple: false,
  });

  return (
    <div
      {...getRootProps()}
      style={{
        border: "2px dashed #cccccc",
        padding: "20px",
        borderRadius: "5px",
        textAlign: "center",
        cursor: "pointer",
      }}
    >
      <input {...getInputProps()} />
      {selectedFile ? (
        <p>{selectedFile.name}</p>
      ) : (
        <p>Drag and drop a file here, or click to select a file</p>
      )}
    </div>
  );
};

// Helper function to check if the file is an image
const getFileType = (fileUrl) => {
  if (!fileUrl) return "blank"; // No URL provided

  const imageExtensions = [".jpg", ".jpeg", ".png", ".gif", ".bmp", ".svg"];
  const videoExtensions = [".mp4", ".mov", ".avi", ".mkv", ".webm"];

  if (imageExtensions.some((ext) => fileUrl.toLowerCase().endsWith(ext))) {
    return "image";
  }
  if (videoExtensions.some((ext) => fileUrl.toLowerCase().endsWith(ext))) {
    return "video";
  }
  return "other"; // Other file types or unsupported extensions
};

// UploadButton Component
const UploadButton = ({ uploading, onUpload, buttonColor, ...props }) => (
  <button
    onClick={onUpload}
    type="button"
    style={{
      marginTop: "20px",
      //   padding: "10px 20px",
      backgroundColor: buttonColor,
      // color: "#FFFFFF",
      border: "none",
      borderRadius: "5px",
      cursor: "pointer",
      ...props.style,
    }}
    disabled={uploading}
  >
    {uploading ? "Uploading..." : "Upload"}
  </button>
);

// UploadedUrl Component
const UploadedUrl = ({ url }) =>
  url ? (
    <div
      style={{
        marginTop: "20px",
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-start", // Adjust alignment of child elements (optional)
        gap: "10px", // Add spacing between child elements (optional)
      }}
    >
      <div style={{ float: "left", width: "100%", marginTop: "15px" }}>
        Uploaded File:{" "}
        <a
          href={url.fileUrl}
          style={{ fontWeight: "bold" }}
          target="_blank"
          rel="noopener noreferrer"
        >
          {url.fileName}
        </a>
      </div>
      {/* <div style={{ float: 'right', width: '30%', textAlign: 'right' }}>
        {getFileType(url.fileUrl) === 'image' ? (
          // Render image if it's an image file
          <a href={url.fileUrl} target="_blank" rel="noreferrer">
            <img src={url.fileUrl} style={{ maxWidth: '200px', maxHeight: '60px' }} alt="" />
          </a>
        ) : getFileType(url.fileUrl) === 'video' ? (
          // Render play button for video file
          <a href={url.fileUrl} target="_blank" rel="noreferrer">
            <img
              src="https://paulavatar.s3.us-east-2.amazonaws.com/play-button.png"
              style={{ maxWidth: '200px', maxHeight: '60px' }}
              alt="Play Video"
            />
          </a>
        ) : (
          // Fallback for other cases
          ''
        )}
      </div> */}
    </div>
  ) : null;

const UploadedUrlImage = ({ url }) => {
  return (
    <>
      {url ? (
        <div style={{ margin: "auto" }}>
          {getFileType(url.fileUrl) === "image" ? (
            // Render image if it's an image file
            <a href={url.fileUrl} target="_blank" rel="noreferrer">
              <img
                src={url.fileUrl}
                style={{ maxWidth: "210px", maxHeight: "80px" }}
                alt=""
              />
            </a>
          ) : getFileType(url.fileUrl) === "video" ? (
            // Render play button for video file
            <a href={url.fileUrl} target="_blank" rel="noreferrer">
              <img
                src="https://paulavatar.s3.us-east-2.amazonaws.com/play-button.png"
                style={{ maxWidth: "200px", maxHeight: "60px" }}
                alt="Play Video"
              />
            </a>
          ) : (
            // Fallback for other cases
            ""
          )}
        </div>
      ) : null}
    </>
  );
};
